const BLOCKED_USER_SIGN_IN_ERROR = 'user is banned';
const BLOCKED_USER_SIGN_IN_MESSAGE = 'Your account has been suspended by your organisation administrator. Please contact them for support.';

const INVALID_CREDENTIALS_ERROR_CODE = 'invalid_credentials';
const INVALID_CREDENTIALS_ERROR_MESSAGE = 'invalid login credentials';

export function getSignInErrorDescription(errorMessage: string): string {
  return errorMessage.trim().toLowerCase() === BLOCKED_USER_SIGN_IN_ERROR
    ? BLOCKED_USER_SIGN_IN_MESSAGE
    : errorMessage;
}

// ENT-4200 (Fix 2): only the invalid-credentials class may be swapped for the
// SSO nudge — GoTrue answers BOTH a wrong password and a non-existent account
// with `invalid_credentials`, so gating on it keeps the nudge existence-safe
// (AC2.2) while letting banned / rate-limit / service / network errors fall
// through to `getSignInErrorDescription` and their actionable copy.
export function isInvalidCredentialsSignInError(
  error: { code?: string | null; message?: string | null } | null | undefined,
): boolean {
  if (!error) return false;
  const code = error.code?.trim().toLowerCase();
  if (code) return code === INVALID_CREDENTIALS_ERROR_CODE;
  return (error.message ?? '').trim().toLowerCase().includes(INVALID_CREDENTIALS_ERROR_MESSAGE);
}
